<template>
  <layout :titlePage="'Extrato de Transações'" :route="{ name: 'carteira' }">
    <section class="c-extract-transaction">
      <div class="columns columns--full is-gapless">
        <div class="column">
          <CExtractTransactions />
          <base-financial-summary
            v-if="
              !walletSummary.loading &&
              !walletSummary.pending &&
              !amountToReceive.pending &&
              !amountToReceive.loading
            "
            v-on:withdraw="withdraw"
            :available="walletSummary.balance"
            :used="-walletSummary.total_used"
            :received="walletSummary.total_credit"
            :pending="amountToReceive"
          >
            <template #icon-reload>
              <base-icon width="24" height="24" name="painel/reload-icon" />
            </template>
            <template #icon-toggle>
              <base-icon
                class="has-text-white"
                width="20"
                height="20"
                name="painel/chevron-up-icon"
              />
            </template>
            <template #icon-information>
              <span
                class="tooltip is-tooltip-multiline is-inline-flex"
                data-tooltip="Este valor será liberado em até 3 dias utéis após o recebido"
              >
                <base-icon
                  style="margin-left: 5px"
                  width="20"
                  height="20"
                  name="painel/info-icon"
                />
              </span>
            </template>
          </base-financial-summary>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import loadingViewMixin from '@/mixins/loadingViewMixin'
import walletDataMixin from '@/mixins/walletDataMixin'
import BaseFinancialSummary from '@/components/Wallet/BaseFinancialSummary.vue'
import CExtractTransactions from '@/components/Wallet/ExtractTransactions.vue'

export default {
  mixins: [loadingViewMixin, walletDataMixin],

  components: {
    layout,
    BaseFinancialSummary,
    CExtractTransactions,
  },

  metaInfo: {
    title: 'Extrato de Transações',
  },

  methods: {
    withdraw() {
      if (this.walletSummary && !this.walletSummary.paypal_account) return ''
      return this.$router.push({ name: 'carteira' })
    },
  },
}
</script>

<style lang="scss">
.c-extract-transaction {
  &__header-icon {
    @media (min-width: $tablet) {
      width: 280px;
      height: 180px;
    }
  }

  @media (min-width: $tablet) {
    margin-top: 20px;
  }
}
</style>
